import { render, staticRenderFns } from "./Preautorizzato.vue?vue&type=template&id=2f0fe2a0&scoped=true&"
import script from "./Preautorizzato.vue?vue&type=script&lang=js&"
export * from "./Preautorizzato.vue?vue&type=script&lang=js&"
import style0 from "./Preautorizzato.vue?vue&type=style&index=0&id=2f0fe2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0fe2a0",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/Preautorizzato.vue
// module id = 446
// module chunks = 0